import { Button, Grid, makeStyles } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { useDropzone } from "react-dropzone";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import React, { useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "8px 40px",
    border: "1px solid #ccc",
    borderRadius: theme.spacing(1),
  },
  dropSection: {
    textAlign: "center",
    padding: theme.spacing(2),
    borderRadius: theme.spacing(0.5),
    lineHeight: "0",
  },
  dropOr: {
    textAlign: "center",
    lineHeight: "0",
    marginBottom: theme.spacing(3),
  },
  selectFilesBtnSection: {
    textAlign: "center",
  },
  error: {
    color: "red",
  },
  selectButton: {
    textTransform: "none",
    fontSize: "13px",
    borderRadius: theme.spacing(2.5),
    padding: "4px 12px",
    fontWeight: 600,
  },
  fileSizeHelp: {
    fontSize: theme.spacing(1.25),
    textAlign: "center",
    marginTop: theme.spacing(0.5),
  },
  closeCircleOuter: {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
    borderRadius: theme.spacing(2.5),
    background: "#E3F8FA",
    cursor: "pointer",
    display: "inline-block",
    textAlign: "center",
    paddingTop: "2px",
  },
  closeCircleInner: {
    color: "red",
  },
  closeIcon: {
    width: "14px",
    height: "14px",
  },
  fileNameGrid: {
    border: "0.5px solid #E6E6E6",
    margin: "8px 0",
    borderRadius: "5px",
    padding: "10px",
  },
  fileName: {
    fontSize: "13px",
    lineHeight: "20px",
    wordBreak: "break-word",
  },
  removeSection: {
    textAlign: "right",
  },
  continueUploadingBtn: {
    textTransform: "none",
    borderRadius: theme.spacing(3),
    background: "#1A82C5",
    fontWeight: 500,
  },
  btnSection: {
    textAlign: "center",
    marginTop: theme.spacing(3),
  },
  errorText: {
    color: "red",
    fontSize: theme.spacing(1.5),
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const FileUpload = ({ getFormData, fieldName = "excelFile" }) => {
  const [latestAcceptFiles, setLatestAcceptFiles] = useState([]);
  const [continueClick, setContinueClick] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validFile, setValidFile] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  const classes = useStyles();
  const dispatch = useDispatch();

  const { getRootProps, getInputProps, open, acceptedFiles } = useDropzone({
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
    multiple: false,
    onDrop: (acceptedFiles) => {
      setErrorMsg("");
      setValidFile(true);
      if (acceptedFiles[0].type.includes("spreadsheetml")) {
        if (acceptedFiles[0].size <= 10485760) {
          setLatestAcceptFiles(acceptedFiles);
        } else {
          setErrorMsg("File size should be less than 10MB");
        }
      } else {
        setErrorMsg("Invalid file format");
      }
    },
  });

  const uploadFile = () => {
    setContinueClick(true);
    const file = acceptedFiles[0];
    const formData = new FormData();
    formData.append(fieldName, file);
    getFormData(formData);
  };

  const removeFiles = () => {
    setLatestAcceptFiles([]);
  };

  useEffect(() => {}, []);

  return (
    <div>
      {latestAcceptFiles.length === 0 || !validFile ? (
        <div className={classes.container}>
          <div {...getRootProps({ className: "dropzone" })}>
            <input {...getInputProps()} />
            <p className={classes.dropSection}>Drag and drop files here</p>
            <p className={classes.dropOr}>or</p>
            <div className={classes.selectFilesBtnSection}>
              <Button
                variant="contained"
                className={classes.selectButton}
                onClick={open}
                disableElevation
              >
                Select Files
              </Button>
            </div>
            <div className={classes.fileSizeHelp}>(max 10MB)</div>
            {!validFile ? (
              <div className={classes.errorText}>File name is invalid</div>
            ) : (
              ``
            )}
            <div className={classes.errorText}>{errorMsg}</div>
          </div>
        </div>
      ) : (
        ``
      )}

      {latestAcceptFiles && latestAcceptFiles.length > 0 && validFile ? (
        <>
          <div className={classes.fileNameSection}>
            <Grid container className={classes.fileNameGrid} spacing={0}>
              <Grid item lg={10} className={classes.fileName}>
                {latestAcceptFiles[0].name}
              </Grid>
              <Grid item lg={2} className={classes.removeSection}>
                <span
                  className={classes.closeCircleOuter}
                  onClick={removeFiles}
                >
                  <span className={classes.closeCircleInner}>
                    <HighlightOffIcon className={classes.closeIcon} />
                  </span>
                </span>
              </Grid>
            </Grid>
          </div>
          <div className={classes.btnSection}>
            <Button
              variant="contained"
              color="primary"
              disableElevation
              onClick={uploadFile}
              className={classes.continueUploadingBtn}
            >
              Continue Uploading
            </Button>
          </div>
        </>
      ) : (
        ``
      )}
    </div>
  );
};

export default FileUpload;
